import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import passwordCheckIcon from "../assets/password-check.svg";
import Breadcrumbs from "../components/Breadcrumbs";
import VocovoLogoBlack from "../assets/VocovoLogoNavbar.png";
import VocovoLogoWhite from "../assets/VocovoLogoNavbarWhite.png";
import logoutIcon from "../assets/login.svg";
import { clearAuth, getUser } from "../auth";
import axios from "../axiosSetup";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "User",
    role: "Role",
    email: "",
    avatar: "",
  });
  const [headerInfo, setHeaderInfo] = useState({
  title: "",
  subtitle: "",
});

  const [openMenu, setOpenMenu] = useState(false);
  const menuRef = useRef();

  // Truncate function -> name > 20 chars
  const getTruncatedName = (name) => {
    if (!name) return "";
    return name.length > 10 ? name.substring(0, 10) + "..." : name;
  };

  // Load user data
  useEffect(() => {
    const storedUser = getUser();
    if (storedUser) {
      setUser({
        name: storedUser.name || "User",
        role: storedUser.role || "Unknown",
        email: storedUser.email || "",
        avatar: storedUser.avatar || "",
      });
    }
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Listen for updates from QuoteDetails
// Listen for updates from QuoteDetails
useEffect(() => {
  const handleHeaderUpdate = () => {
    setHeaderInfo({
      title: sessionStorage.getItem("headerTitle") || "",
      subtitle: sessionStorage.getItem("headerSubtitle") || "",
    });
  };

  window.addEventListener("header-update", handleHeaderUpdate);
  return () => window.removeEventListener("header-update", handleHeaderUpdate);
}, []);

// Clear header when leaving Quote or Order detail pages
useEffect(() => {
  const path = location.pathname;

  // Do NOT clear on quote, order, or product history pages
  if (
    path.startsWith("/quotes/view/") ||
    path.startsWith("/orders/view/") ||
    path.includes("/history")
  ) {
    return;
  }

  // Reset on all other pages
  setHeaderInfo({ title: "", subtitle: "" });
  sessionStorage.removeItem("headerTitle");
  sessionStorage.removeItem("headerSubtitle");
}, [location.pathname]);



const handleLogout = async () => {
  try {
    await axios.post("/auth/logout"); // backend logout
  } catch (e) {
    // ignore 401 / already logged out
  } finally {
    clearAuth();            // clear local auth
    localStorage.clear();
    sessionStorage.clear();

    navigate("/login", { replace: true }); // NO reload
  }
};


  // Dynamic title
  const getHeaderInfo = () => {
    
  const path = location.pathname;
    const storedTitle = sessionStorage.getItem("headerTitle");
const storedSubtitle = sessionStorage.getItem("headerSubtitle");
// MARGIN DETAILS ( /margin-calculator/:id )
if (path.startsWith("/margin-calculator/")) {
  return {
    title: sessionStorage.getItem("headerTitle") || "Margin Details",
    subtitle: sessionStorage.getItem("headerSubtitle") || "View margin calculation details",
  };
}
  switch (path) {
    case "/products":
      return {
        title: "Product Management",
        subtitle: "Search and manage products available across entities",
      };
      case "/products/add-product":
  return {
    title: "Add New Product",
    subtitle: "Create a new product with comprehensive details",
  };

case `/products/edit/${location.pathname.split("/").pop()}`:
  return {
    title: "Edit Product",
    subtitle: "Update product details",
  };

case `/products/${location.pathname.split("/")[2]}/history`:
  return {
    title: sessionStorage.getItem("headerTitle") || "Product History",
    subtitle: sessionStorage.getItem("headerSubtitle") || "",
  };

    case "/discounts":
      return {
        title: "Customer Price Management",
        subtitle: "Define and manage your pricing",
      };

    case "/users":
      return {
        title: "User Management",
        subtitle: "Manage users, roles, and permissions",
      };

    case "/margin-calculator":
      return {
        title: "Margin Calculator",
        subtitle: "Generate accurate quotes with margin validation",
      };

    case "/calculate-margin":
      return {
        title: "Calculate Margin",
        subtitle: "Calculate the profit margin for each product",
      };
      case "/quote-details":
      return {
        title: "PO Details",
        subtitle: "View detailed information about the PO",
      };
      case "/orders":
      return {
        title: "Orders",
        subtitle: "View and manage customer orders",
      };
        case "/orders/add-order":
      return {
        title: "Create Order",
        subtitle: "Generate a new customer order",
      };
case "/orders/edit/"+location.pathname.split("/").pop():
      return {
        title: "Edit Order",
        subtitle: "Update order details",
      };
      case "/orders/view/"+location.pathname.split("/").pop():
  return {
    title: sessionStorage.getItem("headerTitle") || "Order Details",
    subtitle: sessionStorage.getItem("headerSubtitle") || "",
  };

    case "/quotes":
      return {
        title: "PO Template",
        subtitle: "View and Download PO template",
      };

    case "/quotes/add-quote":
      return {
        title: "Create PO Template",
        subtitle: "Generate a new custom PO template",
      };
case "/quotes/edit/"+location.pathname.split("/").pop():
      return {
        title: "Edit Purchase Order",
        subtitle: "Update Purchase Order",
      };

      case "/quotes/view/"+location.pathname.split("/").pop():
      return {
        title: sessionStorage.getItem("headerTitle") || "Purchase Order",
    subtitle: sessionStorage.getItem("headerSubtitle") || "",
      };
    
    // CUSTOMER ROUTES
    case "/customer/dashboard":
      return {
        title: "Home Screen",
        subtitle: "View your activity summary",
      };

    case "/customer/orders":
      return {
        title: "My Orders",
        subtitle: "View and track your placed orders",
      };

    case "/customer/price-listing":
      return {
        title: "My Price List",
        subtitle: "View your price list",
      };

    default:
      return {
        title: "Dashboard",
        subtitle: "Overview of your platform activity",
      };
  }
};

//  const getHeaderTitle = () => {
//   const path = location.pathname;

//   switch (path) {
//     case "/products":
//       return "Product Management";

//     case "/discounts":
//       return "Price Management";

//     case "/users":
//       return "User Management";

//     case "/margin-calculator":
//       return "Margin Calculator";

//     case "/calculate-margin":
//       return "Calculate Margin";

//     // 🔥 NEW ROUTES (FROM NAVBAR)
//     case "/quotes":
//       return "Quotes";

//     case "/quotes/add":
//       return "Create Quote";

//     case "/orders":
//       return "Orders";

//     // 🔥 CUSTOMER ROUTES
//     case "/customer/dashboard":
//       return "Customer Dashboard";

//     case "/customer/orders":
//       return "My Orders";

//     case "/customer/price-listing":
//       return "My Price List";

//     default:
//       return "Dashboard";
//   }
// };


  return (
    <header className="header header-dashboard">
      <div className="navbar-logo">
  <img src={VocovoLogoWhite} alt="Vocovo Logo" />
</div>



      {(() => {
  const { title, subtitle } = getHeaderInfo();
  return (
    <div className="header-text">
         {/* <Breadcrumbs /> */}
      <h1 className="header-title">{headerInfo.title||title}</h1>
      <p className="header-subtitle">{headerInfo.subtitle||subtitle}</p>
    </div>
  );
})()}


      <div className="header-right" ref={menuRef}>
        <div className="profile-container" onClick={() => setOpenMenu(!openMenu)}>
          {user.avatar ? (
            <img src={user.avatar} className="profile-img" alt="user" />
          ) : (
            <div className="profile-circle">{user.name.charAt(0).toUpperCase()}</div>
          )}

          <div className="profile-details">
            <span
              className="profile-name"
              title={user.name} // Tooltip shows FULL name
            >
              {getTruncatedName(user.name)} {/* Truncated display */}
            </span>

            <span className="profile-role">{user.role}</span>
          </div>
        </div>

        {/* Dropdown Menu */}
        {openMenu && (
          <div className="profile-menu">
       <div
  className="profile-menu-item"
  onClick={(e) => {
    e.stopPropagation();

    // No token needed — update-password uses cookie auth
    navigate("/auth/update-password");
  }}
>
              <img src={passwordCheckIcon} alt="" className="menu-icon" />
              Update Password
            </div>

            {/* Divider */}
            <div className="menu-divider"></div>

            <div className="profile-menu-item" onClick={(e) => {
    e.stopPropagation(); 
    handleLogout();
  }}>
              <img src={logoutIcon} alt="Logout" className="menu-icon" />
              Logout
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
